<div class="relative mt-1">
  @if (label()) {
    <label
      class="absolute text-sm text-gray-500 dark:text-gray-400 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white dark:bg-gray-900 px-2 start-1">
      {{label()}}@if (required()) {<span class="font-semibold text-danger">*</span>}
    </label>
  }

  <div class="w-full rounded-lg border border-gray-300 dark:border-gray-600 px-2.5 pt-5 pb-2.5">

    <app-tabs class="space-y-4" (tabChange)="clear()">
      <app-tab title="Draw" key="draw" [disabled]="disabled()">
        <canvas
          #drawCanvas
          class="w-full rounded border border-gray-200 dark:border-gray-700 cursor-crosshair"
          [class.pointer-events-none]="disabled()"
          style="height: 160px; touch-action: none;"
          (pointerdown)="onPointerDown($event)"
          (pointermove)="onPointerMove($event)"
          (pointerup)="onPointerUp()"
          (pointerleave)="onPointerLeave()">
        </canvas>

        <div class="mt-1.5 flex justify-end">
          <button [disabled]="disabled()" type="button" (click)="clear()" class="text-xs text-body enabled:hover:text-danger transition-colors disabled:cursor-not-allowed cursor-pointer">
            Clear
          </button>
        </div>
      </app-tab>

      <app-tab title="Type" key="type" [disabled]="disabled()">
        <div class="flex flex-col gap-2">
          <app-select [disabled]="disabled()" [options]="fonts" [selected]="selectedFont()" (selectedChange)="onFontChange($event)"/>

          <app-text [disabled]="disabled()"
                    placeholder="Full Name"
                    autocomplete="name"
                    [style.font-family]="selectedFont() + ', cursive'" [value]="typedName()"
                    (valueChange)="onTypedNameChange($event.toString())"/>
        </div>
      </app-tab>
    </app-tabs>

    <!-- Offscreen canvas for rendering typed signatures -->
    <canvas #typeCanvas class="hidden" aria-hidden="true"></canvas>

    <!-- Hidden input for form validation participation -->
    <input type="hidden" [ngModel]="signatureValue()" [name]="name()" />
  </div>
</div>

@if (help()) {
  <p class="text-xs text-body px-2 mt-1">{{help()}}</p>
}
